import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent } from '../components/ui/card';
import { useApp } from '../context/AppContext';
import { useToast } from '../hooks/use-toast';

export default function AdminLogin() {
  const nav = useNavigate();
  const { login, user, loading } = useApp();
  const { toast } = useToast();
  const [loginForm, setLoginForm] = React.useState({ email: '', password: '' });
  const [busy, setBusy] = React.useState(false);

  React.useEffect(() => {
    if (!loading && user) nav('/admin');
  }, [user, loading, nav]);

  const submitLogin = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    const r = await login(loginForm.email, loginForm.password);
    setBusy(false);
    if (r.ok) {
      toast({ title: 'С возвращением', description: 'Переходим в кабинет…' });
      nav('/admin');
    } else {
      toast({ title: 'Ошибка входа', description: r.error || 'Неверный email или пароль', variant: 'destructive' });
    }
  };

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-neutral-50">
        <div className="font-clock text-lg text-neutral-500 animate-pulse-soft">Загрузка…</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-neutral-50 to-white">
      <div className="mx-auto max-w-md px-4 py-10 sm:px-6">
        <Button variant="ghost" onClick={() => nav('/')} className="mb-4 text-neutral-600 hover:text-red-600">
          <ArrowLeft className="mr-2 h-4 w-4" /> На главную
        </Button>
        <div className="flex items-center gap-3">
          <img src="/magnum-logo.png" alt="MAGNUM" className="h-11 w-11 rounded-md object-contain" />
          <div>
            <div className="text-base font-extrabold leading-tight sm:text-lg">MAGNUM <span className="text-red-600">ведущий дом спортивного покера</span></div>
            <div className="-mt-0.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-neutral-500">Админ</div>
          </div>
        </div>
        <Card className="mt-6 rounded-2xl border-neutral-200 shadow-lg">
          <CardContent className="p-6">
            <div className="text-lg font-bold text-neutral-900">Вход в панель клуба</div>
            <div className="mt-1 text-sm text-neutral-500">Доступ выдаёт администратор клуба.</div>
            <form onSubmit={submitLogin} className="mt-5 space-y-4">
              <div>
                <Label>Email</Label>
                <Input
                  type="email"
                  autoComplete="email"
                  value={loginForm.email}
                  onChange={(e) => setLoginForm({ ...loginForm, email: e.target.value })}
                  required
                />
              </div>
              <div>
                <Label>Пароль</Label>
                <Input
                  type="password"
                  autoComplete="current-password"
                  value={loginForm.password}
                  onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
                  required
                />
              </div>
              <Button type="submit" disabled={busy} className="h-11 w-full bg-red-600 text-white hover:bg-red-700 disabled:bg-neutral-300">
                {busy ? 'Проверяем…' : 'Войти'}
              </Button>
            </form>
            <div className="mt-5 rounded-lg border border-neutral-200 bg-neutral-50 px-4 py-3 text-xs text-neutral-600">
              Нет аккаунта? Регистрация закрыта — это внутренняя система клуба.
              Обратитесь к администратору, чтобы получить доступ.
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
